export default {
    appTitle: "ALLU",
    common: {
        ok: "OK",
        remove: "Entfernen",
        view: "Ansicht",
        cancel: "Stornieren",
        rename: "Umbennen",
        copyright: "Copyright 2018 ALLU Finland Oy\r\nAlle Rechte Vorbehalten",
        termsOfService: "Nutzungsbedingungen",
        contactInfo: {
            address: "Jokimäentie 1,\r\n16320 Pennala, FINLAND",
            phone: "Tel: ",
            fax: "Fax: +358 8 882 1440",
            email: "Email: ",
        },
        name: "Name",
        email: "Email",
        country: "Land",
        message: "Nachricht",
        send: "Senden",
        scrollIndicator: "Scrollen Sie Nach Unten, Um Mehr Zu Lesen",
    },
    language: {
        cs: "Czech",
        de: "German",
        ee: "Estonian",
        en: "English",
        es: "Spanish",
        fi: "Finnish",
        fr: "French",
        hu: "Hungarian",
        it: "Italian",
        nl: "Dutch",
        no: "Norwegian",
        pl: "Polish",
        pt: "Portuguese",
        ru: "Russian",
        se: "Swedish",
        tr: "Turkish",
        zh: "Chinese",
    },
    startView: {
        title: "Home",
    },
    contactView: {
        title: "ALLU Kontakt",
        locateNearestDealer: "Locate nearest dealer",
        alluDistributors: "ALLU Verteiler",
        nearestDealer: "Your nearest ALLU distributor",
        allDealers: "All ALLU dealers",
        enableGps: "Enable GPS",
        contactUs: "Kontaktieren Sie Uns:",
        validationError: "Bitte Füllen Sie Alle Felder Aus",
        sendSuccess: "Ihre Nachricht Wurde Verschickt, Wir Werden Sie In Kürze Kontaktieren!",
        sendError: "Fehler Beim Senden Der Nachricht. Bitte Stellen Sie Sicher, Dass Sie Mit Dem Internet Verbunden Sind.",
        locateNearestDealerFailed: "Couldn't locate nearest dealer",
    },
    addDevice: {
        typeSerialNumber: "Typ/ Seriennummer",
        add: "Hinzufügen",
        errorSerialRequired: "Geben Sie Eine Seriennummer Ein.",
        errorSerialExists: "Sie Haben Das Gerät Bereits Registriert. Jetzt Ansehen?",
        errorSerialNotFound: "Seriennummer Nicht Gefunden",
    },
    addDeviceView: {
        title: "ALLU Produkt Registrieren",
    },
    deviceApplicationsView: {
        title: "Anwendungen",
    },
    deviceView: {
        specifications: "Spezifikationen",
        documents: "Documents",
        applications: "Applications",
        options: "Options",
        removeDevice: "Remove from My Devices",
        confirmRemoveDevice: "Möchten Sie Dieses Gerät Tatsächlich Entfernen?",
        renameHelp: "Geben Sie Eine Andere Bezeichnung Für Ihr Gerät Ein",
    },
    deviceApplicationView: {
        noApplications: "Anwenderdaten Wurden Noch Nicht Hinzugefügt. Bitte Warten!",
    },
    deviceListView: {
        title: "Mein ALLU",
        noDevices: "Sie Haben Noch Kein Allu Gerät Registriert. Registrieren Sie Ein Gerät Um Starten Zu Können!",
        addDevice: "Allu Produkt Mit Seriennummer Hinzufügen",
        deviceRemoved: "Ein Oder Mehrere Geräte Wurden Aus Der Liste Entfernt, Da Sie Nicht Mehr Existieren!",
    },
    deviceSpecificationsView: {
        title: "Produktspezifikationen",
        wheelLoaderWeight: "Empfohlener Radlader / Dienstgewicht",
        excavatorWeight: "Empfohlener Bagger / Dienstgewicht",
    },
    deviceDocumentView: {
        mustReadWarning: "Bitte Lesen Sie Dieses Dokument Vollständig Bevor Sie Fortfahren.",
        doneReading: "Fertig",
    },
    deviceInfo: {
        serial: "Serie",
        bucket: "Rahmen",
        drum: "Wellen",
        isProject: "Kundenspezifisches Produkt",
    },
    deviceRuntimeReports: {
        title: "Runtime reports",
        chooseCharts: "Choose charts",
        cumulativeUsage: "Cumulative usage",
        usagePerDay: "Usage per day",
        usagePerDayAverage: "Usage per day average",
        usagePerWeek: "Usage per week",
        usagePerMonth: "Usage per month",
        batteryLevelPerDay: "Battery level per day",
        temperaturePerWeek: "Temperature ",
        assetByCalender: "Asset by calender ",
        assetByWorkTime: "Asset by worktime system ",
        legendTimeDay: "Time [day]",
        legendTimeDayOfWeek: "Time [day of week]",
        legendTimeWeek: "Time [week]",
        legendTimeMonth: "Time [month]",
        legendRuntimeHour: "Runtime [hours]",
        legendRuntimePercent: "Runtime [%]",
        changeFilters: "Change filters",
        legendTemperatureWeek: "Temperature [°C]",
        legendBatteryLevel: "Level [%]",
    },
    deviceMaintenance: {
        title: "Maintenance",
        sendServiceData: "Send service data",
        viewServiceRecord: "View service record",
        setupServiceParameters: "Setup service parameters",
        showTransformerLocation: "Show transformer location",
        specification: "Specification",
        partsList: "Parts list",
        troubleshooting: "Troubleshooting",
        warrantyInfo: "Warranty info"
    },
    sendServiceDataView: {
        title: "Send service data",
        chooseService: "Choose service",
        serviceBladeChange: "Blade change",
        serviceGreasing: "Greasing",
        serviceDrumChange: "Drum change",
        serviceMotorChange: "Motor change",
        addComment: "Add comment (optional)"
    },
    nearestDealerView: {
        title: "Nearest dealer",
    },
    safetyGuideView: {
        title: "Sicherheitsanleitung",
    },
    termsOfServiceView: {
        title: "Terms of Service"
    },
};
